module.exports = __webpack_public_path__ + "media/images/icon_level_gold-b7f6c243fccb0dba42cc81feb4e3fdf2.png";